import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html'
})
export class PaginatorComponent implements OnInit, OnChanges {

  @Input() itemsPerPage: number;
  @Input() currentPage: number;
  @Input() totalItems: number;
  @Input() visiblePages: number;
  @Input() hiddeItems?: boolean;
  @Output() pageChange = new EventEmitter<number>();
  @Output() itemsPerPageChange = new EventEmitter<number>();

  private _TOTAL_PAGES: number;
  public pages: number[];
  public firstItem: number;
  public lastItem: number;
  public numOfItems = [5, 10, 15, 25, 50, 100];

  constructor() { }

  ngOnInit() {
    this.calculatePages();
    this.calculatePagesRange();
  }

  ngOnChanges() {
    this.calculatePages();
    this.calculatePagesRange();
  }

  public get totalPages(): number {
    return this._TOTAL_PAGES;
  }

  public calculatePagesRange() {
    this.firstItem = 1 + (this.itemsPerPage * (this.currentPage - 1 < 0 ? 0 : this.currentPage - 1));
    this.lastItem = this.itemsPerPage * this.currentPage < this.totalItems ? this.itemsPerPage * this.currentPage : this.totalItems;
  }

  private calculatePages() {
    this._TOTAL_PAGES = Math.ceil(this.totalItems / this.itemsPerPage);
    this.pages = this.range(this.totalPages);
  }

  public goToFirst() {
    this.pageChange.emit(1);
  }

  public goToLast() {
    this.pageChange.emit(this.pages[this.pages.length - 1]);
  }

  public goTo(page: number) {
    this.pageChange.emit(page);
  }

  public show(page: number) {
    return (page >= (this.currentPage - this.visiblePages)) && (page <= (this.currentPage + this.visiblePages));
  }

  public range(i: number): Array<number> {
    const x = [];
    let j = 1;
    while (x.push(j++) < i) { }
    return x;
  }

  public changeItemsPerPage() {
    this.itemsPerPageChange.emit(this.itemsPerPage);
  }
}
